import {Component, Input, OnInit} from '@angular/core';
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";
import {Subject} from "rxjs";
import {INodeOptions, NodeOptionsObject} from "@app/workflow-common/diagram-view2/models/node.model";

@Component({
    selector: 'app-instance-history',
    templateUrl: './instance-history.component.html',
    styleUrls: ['./instance-history.component.scss']
})
export class InstanceHistoryComponent implements OnInit {

    isLoading: boolean = true;
    isLoadingDiagramView: boolean = false;
    currentPage:number = 1;
    pageLimit:number = 20;
    firstTimeLoad:boolean = false;
    param:any;
    noData: boolean = true;
    dagrunsItems:any[] = [];
    objectName: string = '';
    totalEntriesCount: number = 0;
    filterOptions: any[] = [];
    appliedViewsFilter: any[] = [];
    selectedItem:object = undefined;
    widthChangeEventSubject = new Subject<any>();
    activeDagTasksData: {} = undefined;
    nodeOptions: INodeOptions;
    infiniteScrollOn: boolean = false;

    @Input() workflowId: any = undefined;
    @Input() dagRunId: any = undefined;
    @Input() metaData: any;
    constructor(
        private _workflowHttpService: WorkflowhttpService,
    ) { }

    async ngOnInit() {
        console.log(this.appliedViewsFilter, ' instance');
        this.param = {
            page: this.currentPage,
            limit: this.pageLimit
        };
        await this.getData(true);
        this.nodeOptions = new NodeOptionsObject({
            objectName: this.objectName,
            title: this.metaData.title,
            showAddChild: false,
            isDraftMode: false,
            autosave: false,
            workflowId: this.workflowId,
            metaData: this.metaData,
            viewMode: 'history'
        });
        this.isLoading = false;
    }

    getData(resetPage: boolean = false) {
        return new Promise( resolve => {
            if(resetPage) {
                this.currentPage=1;
                this.firstTimeLoad=true;
            }
            this._workflowHttpService.dagRunnersList(this.workflowId, this.param).subscribe( data => {
                this.firstTimeLoad=false;
                this.dagrunsItems = data['dagruns'];
                this.objectName = data['objectName'];
                this.totalEntriesCount =parseInt( data['totalCount'] );
                this.filterOptions = data['defaultFilters'];
                if(this.totalEntriesCount > 0){
                    this.noData = false;
                }
                resolve(true);
            })
        });
    }

    applyFilters(filter:any) {
        this.appliedViewsFilter.push(filter);
        this.setParam(this.appliedViewsFilter);
        this.getData(true);
    }
    setParam(filter){
        this.param = {
            page: this.currentPage,
            limit: this.pageLimit,
        }
        this.param.filter = filter;

    }
    removeFilter(filter:any) {
        this.appliedViewsFilter.splice(filter, 1);
        this.setParam(this.appliedViewsFilter);
        this.getData(true);
    }

    showDiagramHistory(item) {
        this.selectedItem = item;
        this.isLoadingDiagramView = true;
        this._workflowHttpService.getDagrunTasksList(item.id)
        .subscribe(data => {
            let historyItems = data['historyItems'];
            let sourceBlocks:any = {};
            if(Object.keys(historyItems).length > 0) {
                sourceBlocks = historyItems;
            }
            const activeDagTasksStatus = {
                'dagRunId': item.id,
                'dagSource': data['dagSource'],
                'tasks': sourceBlocks,
            };
            this.activeDagTasksData = activeDagTasksStatus;
            this.isLoadingDiagramView = false;
            this.nodeOptions.tasksStatus = activeDagTasksStatus['tasks'];
        })
    }

    getPropertyAddress(item:any) {
        let address = item.addressline1;
        if(item.address2) {
            address += ', ' + item.address2;
        }
        if(item.addressline3) {
            address += ', '+ item.addressline3;
        }
        if(item.county) {
            address += ', '+ item.county;
        }
        if(item.town) {
            address += ', '+ item.town;
        }
        if(item.postcode) {
            address += ', '+ item.postcode;
        }
        return address;
    }
    getDiaryDescription(item:any) {
        let desc = 'Event type: ';
        if(item.type === 1) {
            desc += 'Normal';
        }
        else if(item.type === 3) {
            desc += 'Job number '+ item.tablepkid;
        }
        else if(item.type === 2) {
            desc += 'Estimate number '+ item.tablepkid;
        }
        else if(item.type === 5) {
            desc += 'Opportunity number '+ item.tablepkid;
        }
        return desc;
    }

    voidCallingOnInit: boolean=true;
    onScrollEnd(event:any) {
        if(this.voidCallingOnInit) {
            this.voidCallingOnInit = false;
            return;
        }
        if(this.infiniteScrollOn) {
           return;
        }
        if(this.totalEntriesCount == this.dagrunsItems.length) {
            return;
        }
        this.infiniteScrollOn = true;
        this.currentPage = this.currentPage + 1;
        this.param = {
            page: this.currentPage,
            limit: this.pageLimit
        };
        this._workflowHttpService.dagRunnersList(this.workflowId, this.param).subscribe( data => {
            this.firstTimeLoad=false;
            this.dagrunsItems = this.dagrunsItems.concat(data['dagruns']);
            this.infiniteScrollOn = false;
        })
    }

}
